/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/layout/custom-search-suggestions.js":
/*!*********************************************************!*\
  !*** ./zrc/scripts/layout/custom-search-suggestions.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n\n(0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('custom-search-suggestions-section', {\n  onLoad() {\n    // when the section loads\n    this.suggestionWrapperClass = '.custom-search-suggestions-wrapper';\n    this.wrapper = this.container.querySelector(this.suggestionWrapperClass);\n    this.showWrapperClass = 'show';\n    this.attachSuggestion();\n    this.showHideWrapperSuggestionDesktop();\n  },\n  attachSuggestion() {\n    var $headerSearch = document.querySelector('#shopify-section-header .header-item-right .header-search');\n    var $headerSearchMobile = document.querySelector('#shopify-section-header .search-modal.modal__content');\n    if ($headerSearch == null) {\n      return;\n    }\n    var wrapperOutdated = $headerSearch.querySelector(this.suggestionWrapperClass);\n    if (wrapperOutdated != null) {\n      wrapperOutdated.remove();\n    }\n    $headerSearch.append(this.wrapper.cloneNode(true));\n    if ($headerSearchMobile == null) {\n      return;\n    }\n    var wrapperOutdatedMobile = $headerSearchMobile.querySelector(this.suggestionWrapperClass);\n    if (wrapperOutdatedMobile != null) {\n      wrapperOutdatedMobile.remove();\n    }\n    $headerSearchMobile.append(this.wrapper.cloneNode(true));\n  },\n  showHideWrapperSuggestionDesktop() {\n    var $suggestionsWrapper = document.querySelector('#shopify-section-header .header-item-right .header-search .custom-search-suggestions-wrapper');\n    var $headerSearchInput = document.querySelector('#shopify-section-header .header-search-input');\n    var $headerSearchButton = document.querySelector('#shopify-section-header .header-search-button');\n    if ($suggestionsWrapper == null || $headerSearchInput == null || $headerSearchButton == null) {\n      return;\n    }\n    this.closeButton = $suggestionsWrapper.querySelector('.custom-search-suggestions-cancel');\n    var closeOpenDropdowns = () => {\n      var $dropdownOpenArray = document.querySelectorAll('#shopify-section-header .desktop-nav-item.with-dropdown.dropdown-open');\n      $dropdownOpenArray.forEach($openDropdown => {\n        $openDropdown.classList.remove('dropdown-open');\n      });\n    };\n    var showWrapper = () => {\n      $suggestionsWrapper.classList.add(this.showWrapperClass);\n      closeOpenDropdowns();\n    };\n    var hideWrapper = () => {\n      $suggestionsWrapper.classList.remove(this.showWrapperClass);\n    };\n    var handleInputListener = () => {\n      if ($headerSearchInput.value !== '') {\n        return;\n      }\n      showWrapper();\n    };\n    var handleFocusListener = () => {\n      if ($headerSearchInput.value !== '') {\n        return;\n      }\n      showWrapper();\n    };\n    var handleClickButtonListener = event => {\n      event.preventDefault();\n      $suggestionsWrapper.classList.toggle(this.showWrapperClass);\n      $headerSearchInput.focus();\n    };\n    var handleClickOut = event => {\n      var target = event.target;\n      if ($suggestionsWrapper.contains(target) || $headerSearchInput.contains(target) || $headerSearchButton.contains(target)) {\n        return;\n      }\n      $suggestionsWrapper.classList.remove(this.showWrapperClass);\n    };\n    this.closeButton.addEventListener('click', hideWrapper);\n    $headerSearchInput.addEventListener('keydown', hideWrapper);\n    $headerSearchInput.addEventListener('input', handleInputListener);\n    $headerSearchInput.addEventListener('focus', handleFocusListener);\n    $headerSearchButton.addEventListener('click', handleClickButtonListener);\n    document.addEventListener('click', handleClickOut);\n  },\n  onSelect() {\n    var $mobileHeaderSearchDetailsModal = document.querySelector('#shopify-section-header .header-search-mobile-wrapper');\n    var $desktopSuggestionWrapper = document.querySelector('#shopify-section-header .header-item-right .header-search-wrapper .custom-search-suggestions-wrapper');\n    if (window.innerWidth <= 780) {\n      // simulamos el evento ya que el componente detailsModal lo necesita\n      var event = {};\n      event.target = $mobileHeaderSearchDetailsModal.querySelector('.modal__toggle');\n      $mobileHeaderSearchDetailsModal.open(event);\n      return;\n    }\n    if ($desktopSuggestionWrapper.classList.contains(this.showWrapperClass) === false) {\n      $desktopSuggestionWrapper.classList.add(this.showWrapperClass);\n    }\n  }\n});\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/layout/custom-search-suggestions.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"custom-search-suggestions": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/layout/custom-search-suggestions.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;